import React from "react";
import {
    Box,
    Tab
} from '@mui/material';
import {
    TabContext,
    TabList,
    TabPanel
} from '@mui/lab';
import UserInfo from "./UserInfo";
import Page from '../../components/Page';
import BusinessInfo from "./BusinessInfo";
import PriceOptionsTab from "./PriceOptions/PriceOptionsTab";
import UserPage from "../users/index";
import LicenseTab from "./LicenseTab";
import RulerTab from "./RulerTab";
import { canAccess } from '../../permissions/canAccess';
import { AppViewIds } from '../../permissions/appViewIds';
import { usePermissionState } from '../../stores/permissionStore';

const ACCOUNT_TABS = [
    { value: '1', appViewId: AppViewIds.AccountUserInfo, label: 'User Info' },
    { value: '2', appViewId: AppViewIds.AccountCompany, label: 'Company' },
    { value: '3', appViewId: AppViewIds.AccountEmployees, label: 'Employees' },
    { value: '4', appViewId: AppViewIds.AccountPriceOptions, label: 'Price Options' },
    { value: '5', appViewId: AppViewIds.AccountLicenses, label: 'Licenses' },
    { value: '6', appViewId: AppViewIds.AccountRulers, label: 'Rulers' },
];

const ManageAccount = () => {
    const [value, setValue] = React.useState('1');
    const permissionState = usePermissionState();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const visibleTabs = ACCOUNT_TABS.filter(
        (tab) => canAccess(tab.appViewId, permissionState)
    );

    React.useEffect(() => {
        if (!permissionState.loaded || visibleTabs.length === 0) {
            return;
        }

        const currentTabAllowed = visibleTabs.some((tab) => tab.value === value);
        if (!currentTabAllowed) {
            setValue(visibleTabs[0].value);
        }
    }, [permissionState.loaded, visibleTabs, value]);

    return (
        <Page title="Account">
            <Box p={3}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'center' }}>
                        <TabList onChange={handleChange}>
                            {visibleTabs.map((tab) => (
                                <Tab key={tab.value} label={tab.label} value={tab.value} />
                            ))}
                        </TabList>
                    </Box>
                    {canAccess(AppViewIds.AccountUserInfo, permissionState) && (
                        <TabPanel value="1"><UserInfo /></TabPanel>
                    )}
                    {canAccess(AppViewIds.AccountCompany, permissionState) && (
                        <TabPanel value="2"><BusinessInfo /></TabPanel>
                    )}
                    {canAccess(AppViewIds.AccountEmployees, permissionState) && (
                        <TabPanel value="3"><UserPage /></TabPanel>
                    )}
                    {canAccess(AppViewIds.AccountPriceOptions, permissionState) && (
                        <TabPanel value="4"><PriceOptionsTab /></TabPanel>
                    )}
                    {canAccess(AppViewIds.AccountLicenses, permissionState) && (
                        <TabPanel value="5"><LicenseTab /></TabPanel>
                    )}
                    {canAccess(AppViewIds.AccountRulers, permissionState) && (
                        <TabPanel value="6"><RulerTab /></TabPanel>
                    )}
                </TabContext>
            </Box>
        </Page>
    );
};

export default ManageAccount;
